import React, { useContext } from 'react';

import { PlayerAdapter } from '@/scenarios/legacy-player/types/instance';

export const { PlayerProvider, usePlayerInstance } = (() => {
    const context = React.createContext<PlayerAdapter | null>(null);

    return { PlayerProvider: context.Provider, usePlayerInstance: () => useContext(context) };
})();
